import React from 'react';
import { Box } from '@mui/material';
import { OnboardingClasses } from '../onboarding.enums';
import { OnboardingStep } from '../onboarding.types';

export const CAPACITY_TOUR: OnboardingStep[] = [
    {
        className: OnboardingClasses.CAPACITY_CARDS,
        nextOnTargetClick: true,
        title: 'What capacity is?',
        placement: 'right',
        borderRadius: 18,
        content: (
            <>
                <Box>
                    In Travelity, the <b>Capacity</b> is a concept that carries
                    information about the number and age categories of customers
                    who can participate in a single event of this product.
                    <br />
                    Capacity is not a vehicle, boat or any other asset - its the
                    information of quantities those assets can carry.
                </Box>
                <br />
                <Box>
                    A single product can have multiple capacities, given that
                    there may be multiple assets of varying sizes that can be
                    used when serving the customers.
                </Box>
            </>
        ),
    },
    {
        className: OnboardingClasses.ADD_CAPACITY_OPTION,
        nextOnTargetClick: true,
        title: 'Add Capacity Option',
        placement: 'right',
        borderRadius: 28,
        content: `
            Tap Add Capacity Option button.
        `,
    },
    {
        className: OnboardingClasses.CAPACITY_TYPES_DROPDOWN,
        nextOnTargetClick: true,
        waitForTarget: true,
        title: 'Capacity Types',
        placement: 'right',
        borderRadius: 18,
        content: (
            <>
                <Box>
                    <b>Flat Count</b> - Choose this if the number of
                    participants of this product doesn&#39;t depend on the age
                    of the participant. For example: Minimum 1, maximum 19
                    participants can be served at the same time.
                </Box>
                <br />
                <Box>
                    <b>Ageband Count</b> - Choose this, in cases when the
                    product can be served to maximum 10 adults and 3 children
                    (because there are car seats)
                </Box>
                <br />
                <Box>
                    <b>Browse</b> - Choose this if you have already created
                    capacities for your other products and want to reuse them
                    here.
                </Box>
            </>
        ),
    },
    {
        className: OnboardingClasses.CAPACITY_NAME,
        waitForTarget: true,
        title: 'Capacity Name',
        placement: 'right',
        borderRadius: 4,
        content: (
            <>
                Name your capacity something that makes sense to you, so you can
                recognize it in the future. For example{' '}
                <b>&quot;Minibus&quot;</b> or <b>&quot;Max 10 seats&quot;</b> or{' '}
                <Box sx={{ whiteSpace: 'nowrap' }}>
                    <b>&quot;Extra large&quot;</b>.
                </Box>
            </>
        ),
    },
    {
        className: OnboardingClasses.CAPACITY_CONTROL_PANEL,
        title: 'Control Panel',
        placement: 'right',
        borderRadius: 16,
        content: `
            If you have filled the capacity info, pressing the checkmark will result in creating the capacity in Travelity.
        `,
    },
    {
        className: OnboardingClasses.ADD_CAPACITY_OPTION,
        nextOnTargetClick: true,
        waitForTarget: true,
        title: 'Add Another Capacity',
        placement: 'right',
        borderRadius: 28,
        content: `
            Try to add another capacity option and Browse to see the capacity you just created.
        `,
    },
];
